import { useTLang } from 'intl/intl';

export function useSFMainContentLang() {
  return {
    orderDetail: {
      header: {
        title: useTLang({ id: 'substitutionFlow.003' }),
        description: useTLang({ id: 'substitutionFlow.004' }),
      },
    },
    flow: {
      header: {
        title: useTLang({ id: 'substitutionFlow.006' }),
        description: {
          first: useTLang({ id: 'substitutionFlow.007' }),
          second: useTLang({ id: 'substitutionFlow.008' }),
        },
      },
      footer: {
        cta: {
          singleItem: useTLang({ id: 'substitutionFlow.009' }),
          multipleItems: useTLang({ id: 'substitutionFlow.010' }),
        },
      },
    },
  };
}
